import { type RefCallBack } from 'react-hook-form'

export const fieldRefHelper = (ref: RefCallBack) => (element: HTMLElement | null) => {
  ref({
    ...element,
    focus: () => {
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    },
  })
}
